import React, { useEffect } from "react";
import { useState } from "react";
import axios from "axios";
import { useGoogleLogin } from "@react-oauth/google";

function Sign() {
  const [isSignIn, setIsSignIn] = useState(
    localStorage.getItem("isSignIn") === "true" || false
  );

  const [username, setUsername] = useState(
    localStorage.getItem("username") || ""
  );
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState(localStorage.getItem("email") || "");
  const [repeatPassword, setRepeatPassword] = useState("");
  // Store email and sign-in status in localStorage when they change
  useEffect(() => {
    localStorage.setItem("email", email);
  }, [email]);

  useEffect(() => {
    localStorage.setItem("isSignIn", isSignIn);
  }, [isSignIn]);
  useEffect(() => {
    localStorage.setItem("username", username);
  }, [username]);

  const jumpToHome = () => {
    window.location.href = "/Home";
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (isSignIn) {
      try {
        const res = await fetch(
          `http://10.0.0.62:8000/api/users/login?username=${username}&password=${password}`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        const data = await res.json();
        console.log(data);
        if (data.id) {
          setIsSignIn(true);
          setEmail(data.email);
          setUsername(data.username);
          jumpToHome();
        }
      } catch (error) {
        alert("Wrong username or password");
      }
    } else {
      try {
        const res = await fetch(
          `http://10.0.0.62:8000/api/users/create_user?username=${username}&password=${password}&email=${email}`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        const data = await res.json();
        console.log(data);
        if (data.id) {
          setIsSignIn(true);
          setEmail(data.email);
          setUsername(data.username);
          localStorage.setItem("email", data.email);
          localStorage.setItem("username", data.username);
          localStorage.setItem("isSignIn", true);
          jumpToHome();
        }
      } catch (error) {
        alert("Username or email already exists");
      }
    }
  };
  const handleLoginGoogle = useGoogleLogin({
    onSuccess: (codeResponse) => {
      console.log("login success", codeResponse);
      // Assuming codeResponse contains the user's access token
      const { access_token } = codeResponse;
      if (access_token) {
        axios
          .get(
            `https://www.googleapis.com/oauth2/v1/userinfo?access_token=${access_token}`,
            {
              headers: {
                Authorization: `Bearer ${access_token}`,
                Accept: "application/json",
              },
            }
          )
          .then((res) => {
            const data = res.data;
            console.log(data);
            setIsSignIn(true);
            setEmail(data.email);
            setUsername(data.name);
            jumpToHome();
          })
          .catch((err) => console.error(err));
      }
    },
    onError: (error) => {
      console.error("login error", error);
    },
  });
  return (
    <>
      <div className="container">
        <div className="login-container">
          <input
            id="item-1"
            type="radio"
            name="item"
            className="sign-in"
            checked={isSignIn}
            onChange={() => setIsSignIn(true)}
          />
          <label htmlFor="item-1" className="item">
            Sign in
          </label>

          <input
            id="item-2"
            type="radio"
            name="item"
            className="sign-up"
            checked={!isSignIn}
            onChange={() => setIsSignIn(false)}
          />
          <label htmlFor="item-2" className="item">
            Sign up
          </label>

          <form onSubmit={handleSubmit} className="login-form">
            <div className="sign-in-htm">
              <div className="group">
                <input
                  placeholder="Username"
                  id="user"
                  type="text"
                  className="input"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                />
              </div>
              <div className="group">
                <input
                  placeholder="Password"
                  id="pass"
                  type="password"
                  className="input"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>
              <div className="hr"></div>
              <div className="footer">
                <a href="#">Forgot Password?</a>
              </div>
              <div className="footer">
                <button
                  type="submit"
                  className="googleButton"
                  onClick={handleLoginGoogle}
                >
                  Login using Google 🚀
                </button>
              </div>
            </div>

            <div className="sign-up-htm">
              <div className="group">
                <input
                  placeholder="Username"
                  id="user"
                  type="text"
                  className="input"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                />
              </div>
              <div className="group">
                <input
                  placeholder="Email address"
                  id="email"
                  type="text"
                  className="input"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
              <div className="group">
                <input
                  placeholder="Password"
                  id="pass"
                  type="password"
                  className="input"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>
              <div className="group">
                <input
                  placeholder="Repeat Password"
                  id="repeatPass"
                  type="password"
                  className="input"
                  value={repeatPassword}
                  onChange={(e) => setRepeatPassword(e.target.value)}
                />
              </div>
              <div className="group">
                <input
                  type="submit"
                  className="button"
                  onClick={() => {
                    if (password !== repeatPassword) {
                      alert("Passwords do not match");
                    }
                  }}
                />
              </div>
              <div className="hr"></div>
              <div className="footer">
                <label htmlFor="item-1" className="item">
                  <button className="already" onClick={() => setIsSignIn(true)}>
                    Already Member?
                  </button>
                </label>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
export default Sign;
